import React from 'react'
import Products from '../../Components/Products/Product'
const Product = () => {
  return (
    <div><Products/></div>
  )
}

export default Product